import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Container } from './components/Styled'
import { Button } from 'lib/ui'
import { ReactComponent as ArrowLeft } from 'resources/svg/icons/angle-left.svg'

export const NoPosts = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const isBlog = pathname === '/blog'

  return (
    <Container>
      {!isBlog && (
        <Button onClick={() => history.push('/blog')}>
          <ArrowLeft />
          Back to Posts
        </Button>
      )}
      <p>No posts yet!</p>
    </Container>
  )
}
